import React from 'react';

type HomeTabContextType = {
    selectedTab: string | null;
    setSelectedTab: (tab: string | null) => void;
};

export const HomeTabContext = React.createContext<HomeTabContextType>({
    selectedTab: null,
    setSelectedTab: () => {},
});

export const useHomeTabContext = () => {
    const context = React.useContext(HomeTabContext);
    return context;
};
